import React from 'react';
import PositionedVideo from 'app/components/rtc/PositionedVideo';
import { useDeviceManagerState } from 'app/containers/rtc/DeviceManagerContext';
import { usePeersPlayback } from 'app/containers/rtc/PeersPlaybackContext';
import { ExtractProps } from 'app/utils/types';
import {
  createRecycledComponent,
} from 'app/components/utilities/RecycledComponentsProvider';

interface IProps {
  fallback?: React.ReactElement<any> | null;
}

type VideoOptions = Pick<ExtractProps<typeof PositionedVideo>, 'disableBackground' |
  'position' | 'crop' | 'onVideoSizeChange' | 'overrideStyles'>;

const Selfie: React.FC<IProps & VideoOptions> = ({
  fallback = null,
  ...props
}) => {
  const devices = useDeviceManagerState();
  const playback = usePeersPlayback();

  const { mirrorPreview, stream } = devices.video;

  if (!playback || !stream) return fallback;

  return (
    <PositionedVideo
      playback={playback}
      src={stream}
      mirror={mirrorPreview}
      disableAudio
      {...props}
    />
  );
};

const RecycledSelfie = createRecycledComponent(
  Selfie,
  () => 'selfie',
);

export default RecycledSelfie;
